import { render } from "./TechnicalSpecs.vue?vue&type=template&id=27d5747c&scoped=true"
import script from "./TechnicalSpecs.vue?vue&type=script&lang=js"
export * from "./TechnicalSpecs.vue?vue&type=script&lang=js"

import "./TechnicalSpecs.vue?vue&type=style&index=0&id=27d5747c&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d5747c"]])

export default __exports__